// import Api from 'services/Api'
import { client } from '@/api/ClientContainer'
import { make } from 'vuex-pathify'

// Store states
const state = {
  loading: false,
  loaded: false,
  voivodeships: [],
  customerEconomicActivity: [],
  courts: [],
  cardType: [],
  cardVehicleType: [],
  cardVendor: []
}

// Store custom actions
const customActions = {
  // Niestandardowe akcje tutaj lub w dedykowanej usludze. Chyba lepiej w store,
  //  co najwyżej wyrzucić do dedykowanego pliku gdy bedzie duzo akcji, np. dictionaryActions.js
  //  Dedykowany service aby obsługiwać całość zadan musiałby też mapować gettery, a nie o to raczej chodzi.

  // manually add load items action
  // loadAll({ dispatch, commit }, force) {
  loadAll({ commit }, force) {
    force = !!force

    // Items are being loaded
    if (state.loading) {
      // console.log('aborting - already loading')
      return
    }

    // Store data already loaded
    if (state.loaded && !force) {
      // console.log('aborting - already loaded')
      return
    }

    commit('SET_LOADED', false)
    commit('SET_LOADING', true)

    let p1 = client.dictionary.getDictionaries().then((response) => {
      var dictonaries = response.data['member'][0]
      // console.log(JSON.parse(JSON.stringify(dictonaries)))
      // console.log(JSON.parse(JSON.stringify(dictonaries.court)))
      // console.log(JSON.parse(JSON.stringify(dictonaries.customerEconomicActivity)))

      // We don use actions here, just mutations
      // dispatch('setCustomerEconomicActivity', dictonaries.customerEconomicActivity)
      // dispatch('setCourts', dictonaries.court)

      commit(
        'SET_CUSTOMER_ECONOMIC_ACTIVITY',
        dictonaries.customerEconomicActivity
      )
      commit('SET_COURTS', dictonaries.court)
      commit('SET_CARD_TYPE', dictonaries.cardType)
      commit('SET_CARD_VEHICLE_TYPE', dictonaries.cardVehicleType)
      commit('SET_CARD_VENDOR', dictonaries.cardVendor)
    })

    let p2 = client.dictionary
      .getVoivodeship()
      .then((res) => res.data)
      .then((hydra) => {
        var entries = hydra['member']
        var voivodeships = entries.map((entry) => {
          return {
            value: entry.value,
            text: entry.label
          }
        })
        // dispatch('setVoivodeships', voivodeships)
        commit('SET_VOIVODESHIPS', voivodeships)
      })

    Promise.all([p1, p2]).finally(function () {
      // console.log('finished loading')
      commit('SET_LOADING', false)
      commit('SET_LOADED', true)
    })
  }
}

// ---------------------------------------------
// Create store

// make all mutations and getters
const mutations = make.mutations(state)
const getters = make.getters(state)
// const actions = make.actions(state)

const actions = {
  // Store doesn't expose any actions
  // ...make.actions('voivodeships'),
  // ...make.actions('customerEconomicActivity'),
  // ...make.actions('courts'),
  // ...make.actions('loaded'),
  // ...make.actions('loading'),
  ...customActions
}

export default {
  namespaced: true, // add this if in module
  state,
  mutations,
  actions,
  getters
}
